import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import { BrowserRouter as Router } from 'react-router-dom';
import { getENV } from 'utils/appHelpers';
import { Amplify } from 'aws-amplify';
import AlertTemplate from 'shared/components/layout/AlertTemplate';
import Loading from 'shared/components/Loading';
import store, { persistor } from './redux/store';
import App from './app';
import Modal from 'react-modal';
import i18n from 'i18next';
import 'scss/app.scss';
import './lang';

const isProduction = getENV() === 'production';
const awsExports = isProduction ? require('prod.aws-exports') : require('stage.aws-exports');

Amplify.configure(awsExports.default);

Amplify.configure({
  API: {
    graphql_headers: () => ({ Language: i18n.language }),
  },
});

Modal.setAppElement('#root');

const options = {
  position: positions.BOTTOM_RIGHT,
  timeout: 5000,
  offset: '30px',
  transition: transitions.SCALE,
  containerStyle: {
    zIndex: 10500, // Higher than modals ($z-modal: 1050) to ensure alerts appear above modals
  },
};

render(
  <Provider store={store}>
    <PersistGate loading={<Loading className='min-vh-100' />} persistor={persistor}>
      <Suspense fallback={<Loading className='min-vh-100' />}>
        <AlertProvider template={AlertTemplate} {...options}>
          <Router basename={process.env.PUBLIC_URL}>
            <App />
          </Router>
        </AlertProvider>
      </Suspense>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);
